import { useState } from "react";
import type { PortalWidget } from "@entrilia/shared/api/portalWidgetsTypes";
import FundSelect from "../../common/FundSelect";
import SwipeableFiltersDrawer from "../../common/reports/mobile/SwipeableFiltersDrawer";
import { usePortfolioWidgetData } from "../widgetHooks";
import WidgetListDialog from "./WidgetListDialog";
import WidgetMobileContent from "./WidgetMobileContent";

interface Props {
  widgetSettings: PortalWidget;
  onClose: () => void;
}

const PortfolioWidgetListDialog = ({ widgetSettings, onClose }: Props) => {
  const {
    parameters,
    report,
    fetchError,
    filteredRows,
    isRunningReport,
    noDataText,
    setSearchValue,
    fundId,
    setFundId,
  } = usePortfolioWidgetData(widgetSettings);

  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  const filterText = parameters?.funds.find((f) => f.id === fundId)?.name;

  return (
    <>
      <WidgetListDialog
        widgetSettings={widgetSettings}
        onSearch={setSearchValue}
        onOpenFilters={() => setIsFiltersOpen(true)}
        onClose={onClose}
        rowCount={filteredRows.length}
        loading={isRunningReport}
        isAnyFilterApplied
        filterText={filterText}
      >
        <WidgetMobileContent
          report={report}
          rows={filteredRows}
          columnsLimit={5}
          noDataText={noDataText}
          loading={isRunningReport}
          fetchError={fetchError}
        />
      </WidgetListDialog>

      <SwipeableFiltersDrawer open={isFiltersOpen} onClose={() => setIsFiltersOpen(false)} disabled={isRunningReport}>
        <FundSelect
          funds={parameters?.funds ?? []}
          selectedFundId={fundId ?? ""}
          onChange={setFundId}
          disabled={isRunningReport}
          width="100%"
        />
      </SwipeableFiltersDrawer>
    </>
  );
};

export default PortfolioWidgetListDialog;
